import { useContext } from 'react';
import { AppThemeContext } from '../context';
import { AppThemeContextType } from '../types';

const useAppTheme = (): AppThemeContextType => {
  const context = useContext(AppThemeContext);

  if (!context) {
    throw new Error('AppThemeContext must be used within a AppThemeProvider');
  }

  return context;
};

export { useAppTheme };
